import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const TX_RESTART_REQUEST = 'TX_RESTART_REQUEST'
export const TX_RESTART_SUCCESS = 'TX_RESTART_SUCCESS'
export const TX_RESTART_FAILURE = 'TX_RESTART_FAILURE'
export const TX_RESTART_RESET = 'TX_RESTART_RESET'

export const transactionRestart = (id) => ({
  [CALL_API]: {
    endpoint: `/api/transactions/restart-callbacks/`,
    types: [TX_RESTART_REQUEST, TX_RESTART_SUCCESS, TX_RESTART_FAILURE],
    method: 'PUT',
    body: { business_id: id },
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const transactionResetErrorMessage = () => ({
  type: TX_RESTART_RESET,
})
